import { Component, input } from '@angular/core';
import { getRangeString } from '../../../../../utils/dayjs/dayjs';
import { MetricFilter } from '../../../../../types/Metrics';

@Component({
  selector: 'app-metrics-graph-title',
  imports: [],
  templateUrl: './metrics-graph-title.component.html',
  styleUrl: './metrics-graph-title.component.css',
})
export class MetricsGraphTitleComponent {
  public title = input<string>();
  public filters = input<MetricFilter[]>();

  protected getSubtitle() {
    if (!this.title()) return '';
    const range = this.filters()?.find((f) => f.type === 'range');
    if (!range) return '';
    const [min, max] = [range.selected.min, range.selected.max].map((v) => v.toString());
    return getRangeString(min, max);
  }
}
